export default profile => {
  var _profile$agency, _profile$agency$image, _profile$agency2, _profile$awards;
  return {
    agencyLogo: (_profile$agency = profile.agency) === null || _profile$agency === void 0 ? void 0 : (_profile$agency$image = _profile$agency.images) === null || _profile$agency$image === void 0 ? void 0 : _profile$agency$image.logo,
    agencyLogoBackgroundColour: (_profile$agency2 = profile.agency) === null || _profile$agency2 === void 0 ? void 0 : _profile$agency2.logoBackgroundColour,
    profilePhoto: profile.images.profilePhoto,
    name: profile.name,
    title: profile.agency.name,
    address: profile.address,
    websiteUrl: profile.website,
    isEmailContactable: profile.emailContactable,
    phoneNumber: profile.phone,
    agencyProfileUrl: profile.agency.profileUrl,
    enquiryEndpoint: profile.enquiryEndpoint,
    agentId: profile.id,
    jobTitle: profile.jobTitle,
    highlightedAwards: (_profile$awards = profile.awards) === null || _profile$awards === void 0 ? void 0 : _profile$awards.filter(award => award.isHighlighted),
    reviewProfile: profile.reviewProfile,
    brandingLevel: profile.brandingLevel
  };
};